/**
 * @generated SignedSource<<36f2b389cfd22d0ca3c4b2b43e648124>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type JobEstimateSourceEnum = "SYSTEM" | "USER";
export type JobScheduleStatusEnum = "AHEAD" | "DELAYED" | "ON_TIME";
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
export type RecordingAvailabilityEnum = "AVAILABLE" | "UNAVAILABLE";
export type TemplateCategoryEnum = "SURGERY" | "TURNOVER";
export type ORColumnQuery$variables = {
  datetimeEnd?: any | null | undefined;
  datetimeStart?: any | null | undefined;
  id: string;
};
export type ORColumnQuery$data = {
  readonly operatingRoom: {
    readonly id: string;
    readonly name: string | null | undefined;
    readonly recordingAvailability: RecordingAvailabilityEnum | null | undefined;
    readonly surgeries: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly actualStartTime: any | null | undefined;
          readonly actualStopTime: any | null | undefined;
          readonly durations: {
            readonly delayAfterMinutes: number | null | undefined;
            readonly dynamicDurationMinutes: number | null | undefined;
            readonly plannedDurationMinutes: number | null | undefined;
          } | null | undefined;
          readonly estimateSource: JobEstimateSourceEnum | null | undefined;
          readonly estimatedStartTime: any | null | undefined;
          readonly estimatedStopTime: any | null | undefined;
          readonly events: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly happenedAt: any | null | undefined;
                readonly id: string;
                readonly type: {
                  readonly id: string;
                  readonly name: string | null | undefined;
                } | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly location: {
            readonly name: string | null | undefined;
          } | null | undefined;
          readonly name: string | null | undefined;
          readonly patientMrn: string | null | undefined;
          readonly patientName: string | null | undefined;
          readonly plannedStart: any | null | undefined;
          readonly plannedStop: any | null | undefined;
          readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
          readonly serviceName: string | null | undefined;
          readonly status: JobStatusEnum | null | undefined;
          readonly surgeonName: string | null | undefined;
          readonly template: {
            readonly category: TemplateCategoryEnum | null | undefined;
          } | null | undefined;
          readonly turnover: {
            readonly actualStartTime: any | null | undefined;
            readonly actualStopTime: any | null | undefined;
            readonly durations: {
              readonly delayAfterMinutes: number | null | undefined;
              readonly dynamicDurationMinutes: number | null | undefined;
              readonly plannedDurationMinutes: number | null | undefined;
            } | null | undefined;
            readonly estimateSource: JobEstimateSourceEnum | null | undefined;
            readonly estimatedStartTime: any | null | undefined;
            readonly estimatedStopTime: any | null | undefined;
            readonly events: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly happenedAt: any | null | undefined;
                  readonly id: string;
                  readonly type: {
                    readonly id: string;
                    readonly name: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly id: string;
            readonly name: string | null | undefined;
            readonly plannedStart: any | null | undefined;
            readonly plannedStop: any | null | undefined;
            readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
            readonly status: JobStatusEnum | null | undefined;
            readonly template: {
              readonly category: TemplateCategoryEnum | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ORColumnQuery = {
  response: ORColumnQuery$data;
  variables: ORColumnQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "datetimeEnd"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "datetimeStart"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recordingAvailability",
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "datetimeEnd",
  "variableName": "datetimeEnd"
},
v8 = {
  "kind": "Variable",
  "name": "datetimeStart",
  "variableName": "datetimeStart"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedStart",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedStop",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedStartTime",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedStopTime",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualStartTime",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualStopTime",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientMrn",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surgeonName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduleStatus",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Durations",
  "kind": "LinkedField",
  "name": "durations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dynamicDurationMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "delayAfterMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDurationMinutes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateSource",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Template",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": [
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v26 = {
  "alias": null,
  "args": [
    (v25/*: any*/)
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "happenedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EventType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "events(first:20)"
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v31 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v25/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Template",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ORColumnQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Location",
        "kind": "LinkedField",
        "name": "operatingRoom",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": "surgeries",
            "args": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "concreteType": "SurgeryConnection",
            "kind": "LinkedField",
            "name": "__ORColumn_surgeries_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SurgeryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Surgery",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Location",
                        "kind": "LinkedField",
                        "name": "location",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/),
                      (v26/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Turnover",
                        "kind": "LinkedField",
                        "name": "turnover",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              (v29/*: any*/),
              (v30/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ORColumnQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Location",
        "kind": "LinkedField",
        "name": "operatingRoom",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v31/*: any*/),
            "concreteType": "SurgeryConnection",
            "kind": "LinkedField",
            "name": "surgeries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SurgeryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Surgery",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Location",
                        "kind": "LinkedField",
                        "name": "location",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v32/*: any*/),
                      (v26/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Turnover",
                        "kind": "LinkedField",
                        "name": "turnover",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v32/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              (v29/*: any*/),
              (v30/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v31/*: any*/),
            "filters": [
              "datetimeStart",
              "datetimeEnd"
            ],
            "handle": "connection",
            "key": "ORColumn_surgeries",
            "kind": "LinkedHandle",
            "name": "surgeries"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bab27a764b6299c130505395e9d4c7d6",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "operatingRoom",
            "surgeries"
          ]
        }
      ]
    },
    "name": "ORColumnQuery",
    "operationKind": "query",
    "text": "query ORColumnQuery(\n  $id: ID!\n  $datetimeStart: DateTime\n  $datetimeEnd: DateTime\n) {\n  operatingRoom(id: $id) {\n    id\n    name\n    recordingAvailability\n    surgeries(first: 20, datetimeStart: $datetimeStart, datetimeEnd: $datetimeEnd) {\n      edges {\n        node {\n          id\n          name\n          plannedStart\n          plannedStop\n          estimatedStartTime\n          estimatedStopTime\n          actualStartTime\n          actualStopTime\n          patientMrn\n          patientName\n          surgeonName\n          serviceName\n          status\n          scheduleStatus\n          location {\n            name\n            id\n          }\n          durations {\n            dynamicDurationMinutes\n            delayAfterMinutes\n            plannedDurationMinutes\n          }\n          estimateSource\n          template {\n            category\n            id\n          }\n          events(first: 20) {\n            edges {\n              node {\n                id\n                happenedAt\n                type {\n                  id\n                  name\n                }\n              }\n            }\n          }\n          turnover {\n            id\n            name\n            plannedStart\n            plannedStop\n            estimatedStartTime\n            estimatedStopTime\n            actualStartTime\n            actualStopTime\n            status\n            scheduleStatus\n            durations {\n              dynamicDurationMinutes\n              delayAfterMinutes\n              plannedDurationMinutes\n            }\n            estimateSource\n            template {\n              category\n              id\n            }\n            events(first: 20) {\n              edges {\n                node {\n                  id\n                  happenedAt\n                  type {\n                    id\n                    name\n                  }\n                }\n              }\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ca5563073fe9b1034e584539ba33ad8";

export default node;
